<template>
  <RouterView />
</template>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
.comp-bg-BANKOS {
  background-color: #158de3 !important;
  color: #2c3e50 !important;
}
.comp-bg-FDC {
  background-color: #3d9209 !important;
  color: #2c3e50 !important;
}
.comp-bg-WPP {
  background-color: #e42222 !important;
  color: #2c3e50 !important;
}
.comp-bg-WPE {
  background-color: #ffcc00 !important;
  color: #2c3e50 !important;
}
.comp-bg-AGENCY {
  background-color: #94818e !important;
  color: #2c3e50 !important;
}
.comp-bg-TAGADA {
  background-color: #a0a0a0 !important;
  color: #44484d !important;
}
</style>
